<template>
  <div>
    <ValidationProvider
      :name="$t('labels.role')"
      :rules="'required'"
      v-slot="{ errors }"
    >
      <v-select
        :items="roles"
        :disabled="disabled"
        :label="$t('labels.role')"
        :error-messages="errors[0]"
        :value="value"
        :multiple="multiple"
        @change="onChange"
        item-text="label"
        item-value="value"
      ></v-select>
    </ValidationProvider>
  </div>
</template>

<script>
import { UserRolesList } from '../utils/constants';


export default {
  name: "RoleSelect",
  methods: {
    onChange(inputValue) {
      this.$emit("input", inputValue || []);
    },

    getCompanyTypes() {
      this.roles = UserRolesList;
    },
  },
  mounted() {
    this.getCompanyTypes();
  },
  data: () => {
    return {
      roles: [],
    };
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
